import React, { Component } from "react";
import {
  Container,
  Dropdown,
  Form,
  Button
} from "semantic-ui-react";
import set from "lodash/set";

import request from "../../utils/request";
import ResponseMessage from "../../components/common/ResponseMessage";

const accountProfile = () => {
  return {
    id: 0,
    username: "",
    password: "",
    password_confirmation: "",
    salt: "",
    first_name: "",
    last_name: "",
    title: "",
    email: "",
    phone_number: "",
    fax_number: "",
    role: "",
    nonprofit_id: 0,
    superadmin: 0
  };
};

const roles = [
  {
    text: "Manager",
    value: "manager"
  },
  {
    text: "Administrator",
    value: "admin"
  }
];

const resetState = () => {
  return {
    isMounted: false,
    isLoading: true,
    xhrStatus: "",
    xhrMessage: "",
    nonProfitList: [
      {
        text: "All Non-Profits",
        value: 0,
        key: 0
      }
    ],
    accountList: [
      {
        key: 0,
        text: "Select Account",
        value: 0
      }
    ],
    accountId: 0,
    profile: accountProfile()
  };
};
class AccountProfile extends Component {
  constructor(props) {
    super(props);

    this.state = resetState();
    let id = this.props.match.params.id ? this.props.match.params.id : 0;
    this.state.accountId = id;

    this.handleChange = this.handleChange.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace("/accounts");
      return;
    }

    this.setState({ isMounted: true });
    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  fetchData = () => {
    let self = this;
    let promises = [request.get(this, "api:/non-profit", {})];
    if (this.state.accountId > 0) {
      promises.push(
        request.get(this, `api:/users/${this.state.accountId}`, {})
      );
    }
    Promise.all(promises).then(function (values) {
      self.setNonprofitList(values[0]);
      if (values[1]) {
        self.setProfile(values[1]);
      }
      self.setState({ isLoading: false });
    });
  };
  handleChange = (e, { name, value }) => {
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  };
  handleContent = e => {
    let name = e.target.dataset.key;
    let value = e.target.textContent;
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  };
  setNonprofitList = result => {
    if (!this.state.isMounted) return false;
    let nonProfitList = this.state.nonProfitList;
    result.data.map((value, index) =>
      nonProfitList.push({
        text: value.name,
        value: +value.id,
        key: +value.id
      })
    );
    this.setState({
      nonProfitList: nonProfitList,
      isLoading: this.state.sellerId === 0 ? false : true
    });
  };
  setProfile = result => {
    let profile = result;
    profile.password = "";
    profile.password_confirmation = "";
    delete profile.salt;
    this.setState({
      profile: profile,
      isLoading: false
    });
  };
  handleSubmit = () => {
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    let submit;
    if (this.state.profile.id > 0) {
      submit = request.put(this, `api:/users/${this.state.profile.id}`, this.state.profile);
    } else {
      submit = request.post(this, "api:/users", this.state.profile);
    }

    submit.then(resp => {
      var message;
      if (resp.errors) {
        message = Object.keys(resp.errors).map(e => {
          return <div>{resp.errors[e][0]}</div>;
        });
      }
      if (resp.status === "error") {
        message = "An account already exists with the provided email address";
      }
      this.setState({
        isLoading: false,
        xhrStatus: (resp.errors || resp.status === "error") ? "error" : resp.success ? "success" : "error",
        xhrMessage: message ? message : resp.message
      });
      if (resp.success) {
        if (this.state.accountId === 0) this.setState({ profile: accountProfile() });
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
    })
  };
  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }
  render() {
    const {
      isLoading,
      xhrStatus,
      xhrMessage,
      nonProfitList,
      profile
    } = this.state;
    return (
      <Container text>
        <Form
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === 'error'}
          onBlur={this.handleDismissPortal}
        >
          <Form.Input
            name="email"
            icon="envelope"
            iconPosition="left"
            label="Email Address"
            placeholder="Email Address"
            value={profile.email}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            type="password"
            name="password"
            fluid
            icon="lock"
            iconPosition="left"
            label="Password"
            placeholder="Password"
            value={profile.password}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            type="password"
            name="password_confirmation"
            fluid
            icon="lock"
            iconPosition="left"
            label="Confirm password"
            placeholder="Confirm password"
            value={profile.password_confirmation}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            name="first_name"
            fluid
            icon="user"
            iconPosition="left"
            label="First Name"
            placeholder="First Name"
            value={profile.first_name}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            name="last_name"
            fluid
            icon="user"
            iconPosition="left"
            label="Last Name"
            placeholder="Last Name"
            value={profile.last_name}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            name="phone_number"
            fluid
            icon="phone"
            iconPosition="left"
            label="Phone"
            placeholder="Phone"
            value={profile.phone_number}
            onChange={this.handleChange}
            required
          />
          <Form.Field required>
            <label>Access Level</label>
            <Dropdown
              name="role"
              button
              basic
              fluid
              className='icon'
              floating
              labeled
              icon='id badge'
              options={roles}
              placeholder={"Select access level..."}
              value={profile.role ? profile.role : ""}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Form.Field>
            <label>Non-Profit</label>
            <Dropdown
              name="nonprofit_id"
              button
              basic
              fluid
              className='icon'
              floating
              labeled
              icon='trophy'
              options={nonProfitList}
              placeholder="All Non-profits"
              value={+profile.nonprofit_id}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Button 
            primary 
            content="Save" 
            floated="right" 
            icon="save"
            onClick={this.handleSubmit} 
          />
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
      </Container>
    );
  }
}

export default AccountProfile;
